import styled from 'styled-components'

export const FilesList = styled.div`
  padding: 10px;
  border-radius: 10px;
  color: #0a0a18;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  border: none;
  white-space: pre-wrap;
  height: auto;
  display: flex;
  gap: 10px;
  align-items: center;
`
export const UploadedItems = styled.div`
  background: #f6f6f6;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #d4d1d1;
  cursor: pointer;
  gap: 6px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;

  span {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  a {
    color: #0a0a18;
    text-decoration: none;
  }

  .icon {
    font-size: 18px;
  }
`
export const UploadedItemsBtn = styled.button<{ $action: 'delete' | 'upload' }>`
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  gap: 6px;
  display: flex;
  align-items: center;
  color: ${(props) => (props.$action === 'delete' ? '#ad1018' : '#0a0a18')};
  background-color: transparent;
  justify-content: flex-start;
  font-size: 18px;
  &:hover {
    background-color: #f6f6f6;
    border: ${(props) =>
      props.$action === 'delete' ? '1px solid #ad1018' : '1px solid #d4d1d1'};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const InputFileForm = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  .file {
    &-upload {
      display: none;
    }

    &-btn {
      padding: 10px 20px;
      background-color: #313131;
      color: #ffffff;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      width: 140px;

      &:disabled {
        background-color: #797979;
      }
    }
  }
`
export const FormBtnsContainer = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  justify-content: center;
`

export const InputFileContainer = styled.div`
  background: #f6f6f6;
  outline: #8e92bc;
  border-radius: 10px;
  color: #0a0a18;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  border: none;
  white-space: pre-wrap;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ItemToUpload = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 8px;

  p {
    flex: 1;
    text-overflow: ellipsis;
  }
`
export const ItemToUploadBtns = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
